export function Footer() {
  return (
    <div className="w-full bg-white border-t p-2 text-center text-xs text-gray-600 print:hidden">
      <a 
        href="https://wa.me/6287862250460" 
        target="_blank" 
        rel="noopener noreferrer"
        className="hover:text-primary transition-colors"
      >
        Dev by JetweB - Version 1.21
      </a>
    </div>
  );
}
